import { Component, EventEmitter, Input, OnChanges, Output, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Bot } from "../../../../../models/bot";
import { PrintDocument } from "../../../../../models/print-document";
import { Message } from "../../../../../models/message";
import { FormControllerService } from "../../../../../services/form-controller/form-controller.service";
import { PrintDocumentControllerService } from "../../../../../services/print-document/print-document-controller.service";
import { MessageControllerService } from "../../../../../services/message-controller/message-controller.service";
import { BotControllerService } from "../../../../../services/role-controller/bot-controller.service";
import { RoleControllerService } from "../../../../../services/role-controller/role-controller.service";
import { ServiceControllerService } from "../../../../../services/service-controller/service-controller.service";
import { Service } from "../../../../../models/service";
import { Store } from "../../../../../services/store.service";
import { TranslatedBaseError } from "../../../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "lodash";
import { environment } from "../../../../../../environments/environment";

@Component({
  selector: "role-bot-manage",
  templateUrl: "./role-bot-manage.component.html",
  providers: [BotControllerService, FormControllerService, ToastrService, PrintDocumentControllerService],
})
export class RoleBotManageComponent extends TranslatedBaseError implements OnInit, OnChanges {
  @Input() public bot = new Bot();
  @Input() public serviceId: string;
  @Input() public fromRole: boolean = false;
  @Input() public showBotAdd: boolean = false;
  @Output() public modalAddedEvent = new EventEmitter();
  @Output() public changedData = new EventEmitter();
  @ViewChild("trans_applicant") public applicant_translation: ElementRef;

  public serviceBots: Bot[];
  public services: Service[] = [];
  public selectedServiceId: string;
  public botId: string;
  public printDocuments: PrintDocument[];
  public fileUploadComponents: any[] = [];
  public messages: Message[] = [];
  public message: Message = null;
  public receivers: any[] = [];
  public name: any;
  public newBot: any;
  public initialValue: string = "";
  public botShortName: string = "";
  public showMessageDrawer: boolean = false;
  public showMessagesList: boolean = false;
  public loadingReceivers: boolean = true;
  public messageData: any = {
    serviceId: null,
    messageType: "MESSAGE",
  };
  public messageToEdit: any = null;
  public availableChannels: Array<{ id: string, name: string, disabled?: boolean, icon?: string }> = [
    { id: "EMAIL", name: "Email", disabled: false, icon: "envelope" },
    { id: "SMS", name: "SMS", disabled: false, icon: "mobile" },
    { id: "WHATSAPP", name: "WhatsApp", disabled: true, icon: "comments" },
  ];
  public isLoading: boolean = false;
  @Output() public addedFromRoleEvent = new EventEmitter();

  constructor(private botController: BotControllerService,
    private printDocController: PrintDocumentControllerService,
    private messageControllerService: MessageControllerService,
    private roleControllerService: RoleControllerService,
    private serviceControllerService: ServiceControllerService,
    private formControllerService: FormControllerService,
    public store: Store,
    private route: ActivatedRoute,
    toastr: ToastrService,
    public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnChanges() {
    if (!this.fromRole) {
      if (this.bot && !this.bot.id) {
        this.reloadBot();
        this.initLists();
      }
    }
    if (!this.messageData.serviceId && this.serviceId) {
      this.messageData.serviceId = this.serviceId;
    }
  }

  public ngOnInit() {
    this.messageData.serviceId = this.serviceId ? this.serviceId : null;
    this.initLists();
  }

  public initLists() {
    console.log("--- initLists", this.bot);
    if (this.bot && this.bot.botType === "message") {
      if (this.bot.selectedMessage) {
        this.loadMessage(this.bot.selectedMessage);
      }
      this.loadReceivers();
    }
    if (this.bot && this.bot.botType === "document") {
      if (this.bot.category !== "document_upload") {
        this.loadServiceDocuments();
      } else {
        this.loadServiceFileUploadComponents();
      }
    }
    if (this.bot && (this.bot.botType !== "message" && this.bot.botType !== "document" && this.bot.botType !== "link")) {
      this.getServiceBotsList();
    }
    if (this.bot && this.bot.botType === "link") {
      this.loadServices();
      if (this.bot.isEregistrationService && this.bot.redirectUrl) {
        const urlParts = this.bot.redirectUrl.split("/");
        // Assuming URL format ends with /services/SERVICE_ID or /services-new/SERVICE_ID
        // and potentially query params.
        // Let's try to extract the ID.
        // Based on ServiceDetailComponent: url += ... + services/ID + ...
        // We can try to find the ID in the URL.
        // Or simpler: iterate services and check if URL contains their ID? No, too slow.
        // Let's parse the URL.
        // Example: http://.../services/123?attemptAutoLogin=1
        // Split by '/' and take the part after 'services' or 'services-new'.
        let idPart = "";
        if (this.bot.redirectUrl.includes("/services/")) {
          idPart = this.bot.redirectUrl.split("/services/")[1];
        } else if (this.bot.redirectUrl.includes("/services-new/")) {
          idPart = this.bot.redirectUrl.split("/services-new/")[1];
        }
        if (idPart) {
          // Remove query params if any
          this.selectedServiceId = idPart.split("?")[0];
        }
      }
    }
  }

  public addNewBot() {
    if (!this.bot.botType) {
      this.toastr.warning(this.translate("Please select a bot type"));
      return;
    }
    if (!this.isLoading) {
      this.isLoading = true;
      this.bot.name = this.bot.name.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");
      this.bot.shortName = this.bot.shortName.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");
      this.bot.name = this.bot.name.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");
      this.bot.shortName = this.bot.shortName.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");

      if (this.bot.isEregistrationService && this.selectedServiceId) {
        let lang = this.store.state.common.lang;
        // @ts-ignore
        if (this.translateService._$supportedLangs && this.translateService._$supportedLangs.length > 0 && !this.translateService._$supportedLangs.includes(lang)) {
          // @ts-ignore
          lang = this.translateService._$supportedLangs[0];
        }
        let url;
        if (!environment.USE_NEW_DS) {
          url = environment.E_REGISTRATIONS_URL + lang + "/";
        } else {
          url = environment.E_REGISTRATIONS_URL;
        }
        url += `${environment.USE_NEW_DS ? 'services' : 'services-new'}/${this.selectedServiceId}${environment.USE_NEW_DS ? '' : '?attemptAutoLogin=1'}`;
        this.bot.redirectUrl = url;
      }

      this.botController.createBot(this.serviceId, this.bot).subscribe(
        (data) => {
          this.newBot = data;
          if (this.fromRole) {
            this.addedFromRoleEvent.emit(data);
          }
          this.modalAddedEvent.emit();
          this.responseSuccessful("Bot created!");
        },
        (error) => {
          this.isLoading = false;
          this.showErrorMessage(error);
        },
      );
    }
  }

  public autoSave() {
    if (this.bot.botType !== "link") {
      this.saveBot();
    }
  }

  public saveBot() {
    if (this.bot && this.bot.id) {
      this.bot.name = this.bot.name.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");
      this.bot.shortName = this.bot.shortName.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");
      this.bot.name = this.bot.name.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");
      this.bot.shortName = this.bot.shortName.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");

      if (this.bot.isEregistrationService && this.selectedServiceId) {
        let lang = this.store.state.common.lang;
        // @ts-ignore
        if (this.translateService._$supportedLangs && this.translateService._$supportedLangs.length > 0 && !this.translateService._$supportedLangs.includes(lang)) {
          // @ts-ignore
          lang = this.translateService._$supportedLangs[0];
        }
        let url;
        if (!environment.USE_NEW_DS) {
          url = environment.E_REGISTRATIONS_URL + lang + "/";
        } else {
          url = environment.E_REGISTRATIONS_URL;
        }
        url += `${environment.USE_NEW_DS ? 'services' : 'services-new'}/${this.selectedServiceId}${environment.USE_NEW_DS ? '' : '?attemptAutoLogin=1'}`;
        this.bot.redirectUrl = url;
      }

      this.botController.saveBot(this.bot).subscribe(
        () => {
          this.responseSuccessful("BOT saved!");
          this.changedData.emit();
        },
        (error) => this.showErrorMessageWithTitle("Bot saving error!", error),
      );
    }
  }

  public reloadBot() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.botId = params.botId;
      if (this.botId && !this.showBotAdd) {
        this.botController.getBot(this.botId).subscribe(
          (data) => {
            this.bot = data;
            this.initLists();
          },
          (error) => this.showErrorMessageWithTitle("Loading error!", error),
        );
      }
    });
  }

  public getServiceBotsList() {
    this.botController.getServiceBots(this.serviceId).subscribe(
      (data) => this.serviceBots = data,
    );
  }

  public startEdit(event: any) {
    this.initialValue = event.target.value;
  }

  public submitEditOnFocus(event: any, loadItems: boolean) {
    if (event.target.value !== this.initialValue) {
      if (loadItems && this.bot.category !== "document_upload") {
        this.fileUploadComponents = [];
        this.loadServiceDocuments();
      } else if (loadItems) {
        this.printDocuments = [];
        this.loadServiceFileUploadComponents();
      }
      this.initialValue = "";
      this.autoSave();
    }
  }

  public loadDocuments() {
    if (this.bot.botType === "document") {
      if (this.bot.category !== "document_upload") {
        this.loadServiceDocuments();
      } else {
        this.loadServiceFileUploadComponents();
      }
    }
    if (this.bot.botType === "message") {
      this.loadSmsReceivers();
    }
    if (this.bot.botType === "link") {
      this.loadServices();
    }
  }

  public updateDoc(event: any) {
    this.bot.selectedPrint = event;
    this.saveBot();
  }

  public updateFuc(event: any) {
    this.bot.selectedFileUploadComponentKey = event;
    this.saveBot();
  }

  public updateMessage(event: any) {
    console.log(event);
    this.bot.selectedMessage = event;
    this.saveBot();
  }

  public updateReceiver(event: any) {
    console.log(event);
    this.bot.selectedReceiver = event;
    this.saveBot();
  }

  public updateChannel(event: any) {
    console.log(event);
    this.bot.selectedChannel = event;
    this.loadReceivers();
    this.saveBot();
  }

  public updateNotificationAlso(event: any) {
    console.log(event);
    this.bot.sendAlert = event;
    this.saveBot();
  }

  public nameChanged(value): void {
    this.botShortName = value;
    this.bot.shortName = this.botShortName.substring(0, 20);
  }

  public loadReceivers() {
    const receivers = [];
    this.loadingReceivers = true;
    switch (this.bot.selectedChannel) {
      case "SMS":
      case "WHATSAPP":
        this.loadSmsReceivers();
        break;
      case "EMAIL":
      default:
        this.loadEmailReceivers();
        break;
    }
  }

  public getMessageIcon(message: Message) {
    switch (message.channel) {
      case "EMAIL":
        return "envelope";
      case "SMS":
        return "mobile";
      case "WHATSAPP":
        return "comments";
      default:
        return "envelope";
    }
  }

  public loadSmsReceivers() {
    const receivers = [];
    this.loadingReceivers = true;
    this.roleControllerService.getRolesList(this.serviceId, true).subscribe((data) => {
      if (data) {
        const applicants = data.filter((role) => role.assignedTo === "applicant").map((role) => ({ id: role.id, name: "Role: " + this.getTranslation(role.name) }));
        for (let i = 0; i < applicants.length; i++) {
          receivers.push(applicants[i]);
        }
      }
      this.formControllerService.getServiceFields(this.serviceId, { filterByType: "textfield,number", isCopyValueFrom: false }).subscribe((data2) => {
        if (data2) {
          const fields = data2.map((field) => ({ id: field.fullKey, name: this.getTranslation("Field") + ": " + (field.workingLabel || field.workingTitle || field.fullName) }));
          for (let j = 0; j < fields.length; j++) {
            receivers.push(fields[j]);
          }
        }
        receivers.push({ id: "applicant-phone", name: "Tag: applicant-phone" });
        this.receivers = receivers;
        this.loadingReceivers = false;
      });
    });
  }

  public loadEmailReceivers() {
    const receivers = [];
    this.loadingReceivers = true;
    this.roleControllerService.getRolesList(this.serviceId, true).subscribe((data) => {
      if (data) {
        const applicants = data.filter((role) => role.assignedTo === "applicant").map((role) => ({ id: role.id, name: "Role: " + this.getTranslation(role.name) }));
        for (let i = 0; i < applicants.length; i++) {
          receivers.push(applicants[i]);
        }
      }
      this.formControllerService.getServiceFields(this.serviceId, { filterByType: "textfield,email", isCopyValueFrom: false }).subscribe((data2) => {
        if (data2) {
          const fields = data2.map((field) => ({ id: field.fullKey, name: "Field: " + (field.workingLabel || field.workingTitle || field.fullName) }));
          for (let j = 0; j < fields.length; j++) {
            receivers.push(fields[j]);
          }
        }
        receivers.push({ id: "applicant-email", name: "Tag: applicant-email" });
        this.receivers = receivers;
        this.loadingReceivers = false;
      });
    });
  }

  public getTranslation(name: string) {
    if (name === "Applicant") {
      return this.applicant_translation !== undefined ? this.applicant_translation.nativeElement.textContent.trim().toString() : name;
    } else {
      return name;
    }
  }

  public loadServiceDocuments() {
    this.printDocuments = [];
    this.printDocController.getDocumentList(this.serviceId, true).subscribe(
      (data) => {
        console.log("--- documents", data);
        this.printDocuments = _.orderBy(data, ["name"], ["asc"]);
      },
    );
  }

  public loadServiceFileUploadComponents() {
    this.fileUploadComponents = [];
    this.formControllerService.getServiceFields(this.serviceId, { filterByType: "file", onlyEventComponents: true }).subscribe((fields) => {
      this.fileUploadComponents = _.orderBy(fields, ["name"], ["asc"]);
    });
  }

  public loadMessage(id: any) {
    this.messages = [];
    this.messageControllerService.getMessage(id).subscribe(
      (data) => {
        console.log("--- message", data);
        this.message = data;
        this.loadReceivers();
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
    );
  }

  public clearMessage() {
    this.message = null;
    this.bot.selectedMessage = null;
    this.saveBot();
  }

  public addMessage(event: any) {
    console.log("--- Please add message", event);
    this.message = event?.message;
    this.bot.selectedMessage = event?.message?.id;
    this.showMessageDrawer = false;
    this.showMessagesList = false;
    this.saveBot();
  }

  public editMessage(event: any) {
    console.log("--- Please edit message", event);
    this.message = event;
    this.showMessageDrawer = true;
  }

  public closeSection(event) {
    this.message = null;
    this.showMessageDrawer = false;
  }

  public openMessagesList() {
    this.showMessagesList = true;
  }

  public openMessageEdit() {
    this.messageToEdit = this.message;
    this.showMessagesList = true;

  }

  public closeMessagesList() {
    this.messageToEdit = null;
    this.showMessagesList = false;
  }

  public loadServices() {
    this.serviceControllerService.getServicesList().subscribe(
      (data) => {
        this.services = data
          .filter(s => s.numberOfPublishes > 0 && !s.archived)
          .sort((a, b) => a.name.localeCompare(b.name));
      },
      (error) => this.showErrorMessage(error)
    );
  }

  public onEregistrationServiceChange() {
    if (this.bot.isEregistrationService) {
      this.bot.redirectUrl = null;
    }
  }
}
